import { Link } from "react-router-dom";
import AnagramsSampleImage from "../assets-optimized/ai/anagrams_sample.webp";
import CheckersSampleImage from "../assets-optimized/ai/checkers_sample.webp";
import Connect4SampleImage from "../assets-optimized/ai/connect4_sample.webp";
import GomokuSampleImage from "../assets-optimized/ai/gomoku_sample.webp";
import MancalaSampleImage from "../assets-optimized/ai/mancala_sample.webp";
import OthelloSampleImage from "../assets-optimized/ai/othello_sample.webp";
import SeaBattleSampleImage from "../assets-optimized/ai/sea_battle_sample.webp";
import WordBitesSampleImage from "../assets-optimized/ai/word_bites_sample.webp";
import WordHuntSampleImage from "../assets-optimized/ai/word_hunt_sample.webp";
import SpellingBeeSampleImage from "../assets-optimized/ai/spelling_bee_sample.webp";
import LetterBoxedSampleImage from "../assets-optimized/ai/letter_boxed_sample.webp";
import { pageRoutes } from "../utils/urls";
import React from "react";



const GameHome = () => {
    return (
        <div className="min-h-screen flex flex-col items-center gap-4 pt-4">
            <div className="w-full max-w-2xl flex flex-col items-center gap-6 border border-brd-muted rounded-lg p-8 bg-background-muted shadow-lg">
                <h1 className="text-4xl font-extrabold text-text-base mb-4">Game Pigeon AIs</h1>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-6 w-full">
                    <GameLink to={pageRoutes.Anagrams} label="Anagrams" image={AnagramsSampleImage} />
                    <GameLink to={pageRoutes.Checkers} label="Checkers" image={CheckersSampleImage} />
                    <GameLink to={pageRoutes.Connect4} label="Connect 4" image={Connect4SampleImage} />
                    <GameLink to={pageRoutes.Gomoku} label="Gomoku" image={GomokuSampleImage} />
                    <GameLink to={pageRoutes.Mancala} label="Mancala" image={MancalaSampleImage} />
                    <GameLink to={pageRoutes.Othello} label="Othello" image={OthelloSampleImage} />
                    <GameLink to={pageRoutes.SeaBattle} label="Sea Battle" image={SeaBattleSampleImage} />
                    <GameLink to={pageRoutes.WordBites} label="Word Bites" image={WordBitesSampleImage} />
                    <GameLink to={pageRoutes.WordHunt} label="Word Hunt" image={WordHuntSampleImage} />
                </div>
            </div>
            <div className="w-full max-w-2xl flex flex-col items-center gap-6 border border-brd-muted rounded-lg p-8 bg-background-muted shadow-lg">
                <h1 className="text-4xl font-extrabold text-text-base mb-4">NYT Mini Game AIs</h1>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-6 w-full">
                    <GameLink to={pageRoutes.SpellingBee} label="Spelling Bee" image={SpellingBeeSampleImage} />
                    <GameLink to={pageRoutes.LetterBoxed} label="Letter Boxed" image={LetterBoxedSampleImage} />
                </div>
            </div>
            <div className="bg-background-muted shadow-lg rounded-lg p-8 max-w-2xl text-center text-text-base">
                <h1 className="text-4xl font-extrabold text-primary-base-600 mb-4">About</h1>
                <p className="text-lg mb-4">
                    <span>This project solves </span>
                    <span className="font-semibold">NYT mini games</span>
                    <span> and </span>
                    <span className="font-semibold">GamePigeon games</span>
                    <span> using AI!</span>
                </p>
                <p className="text-lg">
                    Click the links above to try them out!
                </p>
            </div>
        </div>
    );
};

interface GameLinkProps {
    to: string;
    label: string;
    image?: string;
}

const GameLink: React.FC<GameLinkProps> = ({ to, label, image }) => {
    return (
        <Link
            to={to}
            className="relative flex items-center justify-center aspect-square rounded-xl px-4 py-2 text-text-light hover:bg-primary-base hover:text-text-contrast transition-colors transition-transform shadow group transform hover:scale-105 duration-300"
        >
            {image && (
                <img
                    src={image}
                    alt={label}
                    className="absolute inset-0 w-full h-full object-cover rounded-xl"
                />
            )}
            <span className="relative z-10 text-xl font-bold text-center px-2 py-1 rounded bg-gray-900 bg-opacity-60 group-hover:bg-primary-base group-hover:bg-opacity-100 transition-colors duration-150 whitespace-nowrap">
                {label}
            </span>
            {image && (
                <div className="absolute inset-0 bg-black bg-opacity-30 rounded-xl" />
            )}
        </Link>
    );
};

export default GameHome;
